import React, {Component} from 'react';
import './FilterDoctor.css';
import Userpic2 from '../../img/Userpic2.jpg';
import Userpic from '../../img/Userpic.jpg';
import ApiConnector from '../api/ApiConnector'
import GlobalStore from "../../store/GlobalStore";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactQueryParams from 'react-query-params';
import TagManager from 'react-gtm-module';
import {config} from '../../config.js';
import ReactPixel from 'react-facebook-pixel';

const fbPixelOptions = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};

ReactPixel.init('615166872018376', null, fbPixelOptions);

class FilterDoctor extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.openAllDoctors = this.openAllDoctors.bind(this);
        this.state = {
            ApiDoctorList: [],
            loader: true
        };
    }

    componentDidMount() {
        let currentSubCategoryId = GlobalStore.getInstance().data['categories'];
        let currentOfficeId = GlobalStore.getInstance().data['office'];

        let getApiDoctorList = ApiConnector.getDoctorsList(currentSubCategoryId, currentOfficeId);
        let objectDoctors = {};
        getApiDoctorList
            .then(data => {
                // формуємо об*єкт усіх докторів (id та розширене ім*я) та записуємо у глобальний GlobalStore для подальшого використання
                let objectDoctorList = data.map((item) => {
                    return objectDoctors = {
                        doctorId: item.Id,
                        doctorName: item.Person.DisplayName,
                        doctorImageUrl: item.ImageUrl
                    }
                });
                // GlobalStore.getInstance().data['doctors'] = objectDoctorList;
                this.props.getDoctorList(objectDoctorList);
                // GlobalStore.getInstance().data['doctors'] = undefined;


                // виводимо усіх докторів для фльтрів
                let resultApiDoctorList = data.map((item) => {
                    let imgDoctorSrc;
                    let clickFilterDoctorAction = this.clickFilterDoctor.bind(this, item);

                    if (item.ImageUrl !== null) {
                        imgDoctorSrc = item.ImageUrl;
                    } else {
                        imgDoctorSrc = Userpic;
                    }

                    return (
                        <div className="col-xs-12 col-md-6" key={item.Id}>
                            <div className="stepDoctorItem btn-6" onClick={clickFilterDoctorAction} id={item.Id}>
                                <span className="ripplesCircle"></span>
                                <div className="col-xs-5">
                                    <img className="doctorItemImg" alt={item.Person.DisplayName} src={imgDoctorSrc}/>
                                </div>
                                <div className="col-xs-7">
                                    <div className="doctorItemName">{item.Person.DisplayName}</div>
                                    <div className="doctorItemJob">{item.JobTitle}</div>
                                    <div className="doctorItemDisc">{item.Description}</div>
                                </div>
                            </div>
                        </div>
                    )
                });

                this.setState({ApiDoctorList: resultApiDoctorList, loader: false});

            }).catch(() => {
            this.setState({loader: false});
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.componentDidMount();
            });
        });

        if(GlobalStore.getInstance().data['openAllDoctors'] === true) {
            this.openAllDoctors();
            GlobalStore.getInstance().data['openAllDoctors'] = false

            ApiConnector.getOffices(GlobalStore.getInstance().data['categories'])
                .then(data => {
                    GlobalStore.getInstance().data['officesList'] = {};
                    data.map((item) => {
                        GlobalStore.getInstance().data['officesList'][item.Id] = item;
                    });
                })
        }
    }

    clickFilterDoctor(item, e) {
        GlobalStore.getInstance().data['filterDoctorId'] = item.Id;
        GlobalStore.getInstance().data['filterDoctorName'] = item.Person.DisplayName;

        const tagManagerArgsUniversal = {
            gtmId: 'GTM-5MHWB3M',
            dataLayer: {
                event: 'elementHover',
                eventCategory: 'appointment doctor selected',
                eventAction: GlobalStore.getInstance().data['filterDoctorName'],
                eventLabel: new Date().toString()
            }
        };

        if (this.queryParams.env !== "test" && config.environment === "prod") {
            TagManager.initialize(tagManagerArgsUniversal);
            ReactPixel.track(
                'ViewContent',
                {
                    content_name: GlobalStore.getInstance().data['filterDoctorName'],
                    content_category: 'appointment doctor selected',
                    value: 0.05,
                    currency: 'USD',
                    referrer: document.referrer,
                    userAgent: navigator.userAgent,
                    language: navigator.language
                });
        }

        // console.log(GlobalStore.getInstance().data);
        this.props.openCurrentTab();
    }

    openAllDoctors() {
        this.props.disableFilterDoctor();
        this.props.openCurrentTab();
    }

    render() {
        return (
            <div className="parentForLoader col-xs-12">
                {(this.state.loader === true) ? <div className="localLoader">
                    <div className="localSpinner"></div>
                </div> : ''}
                {/* clear doctor filter and show all doctors*/}
                <div className="col-xs-12 col-md-6">
                    <div className="stepDoctorItem firstDoctorListElement btn-6" onClick={this.openAllDoctors}>
                        <span className="ripplesCircle"></span>
                        <div className="col-xs-5">
                            <img className="doctorItemImg" alt="allUser" src={Userpic2}/>
                        </div>
                        <div className="col-xs-7">
                            <div className="doctorItemName">Kuka tahansa</div>
                            <div className="doctorItemJob"></div>
                            <div className="doctorItemDisc">Kelpuuttaa kaikkien hoitohenkilöiden vapaat ajat</div>
                        </div>
                    </div>
                </div>
                {this.state.ApiDoctorList}

                <NotificationContainer/>

            </div>
        )
    }
}

export default FilterDoctor;



// WEBPACK FOOTER //
// ./src/components/Step_3/FilterDoctor.jsx